
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 130 162","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 156V55.14a6 6 0 011.764-4.248L51.056 1.75A6 6 0 0155.292 0H124a6 6 0 016 6v150a6 6 0 01-6 6H6a6 6 0 01-6-6z","fill":"#EC4235"}}),_c('path',{attrs:{"d":"M49.586 12.414L17.414 44.586c-1.26 1.26-.367 3.414 1.414 3.414H51a2 2 0 002-2V13.828c0-1.781-2.154-2.674-3.414-1.414z","fill":"#fff"}})])
          )
        }
      }
    